const DEFAULT_INTERMEDIARY_PREFIX = 'Intermediary ';

export const formatDisplayTitle = (systemName: string, title: string) => {
  return title.replace(DEFAULT_INTERMEDIARY_PREFIX, '');
};
